/* src/app/shared/components/new-drawer/search/search-drawer/search-drawer.component.scss */
:host {
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  padding: 20px;
  overflow: hidden;
}
.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
.container__header {
  display: flex;
  flex-direction: column;
}
.container {
  background-color: white;
}
.container__title {
  font-size: 1.8rem;
  font-weight: 500;
  color: #1f3cff;
  text-align: center;
  margin-bottom: 20px;
}
.container__form {
  display: flex;
  flex-direction: column;
  padding: 0 15% 30px;
  border-bottom: 1px solid #b4b4b4;
  gap: 20px;
}
.container__content {
  display: flex;
  flex: 1;
  overflow-y: auto;
}
/*# sourceMappingURL=search-drawer.component.css.map */
